import * as React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import styled from 'styled-components';
import Option from './Option';
import { singleColumnMaxWidth } from '../../../appComponents/cssConstants';

const Column = (props: ColumnProps) => {
	return (
		<StyledColumn $floatToRight={props.floatToRight}>
			<Title>{props.column.title}</Title>
			<Droppable droppableId={props.column.id}>
				{(provided, snapshot) => (
					<OptionList ref={provided.innerRef} {...provided.droppableProps} $isDraggingOver={snapshot.isDraggingOver}>
						{props.options.map((option: any, index: number) => (
							<Option
								key={option.id}
								option={option}
								index={index}
								isDragDisabled={props.isDragDisabled}
								onValueChange={props.onValueChange}
								isMovedToNewColumn={props.column.id === 'destination'}
							/>
						))}
						{provided.placeholder}
					</OptionList>
				)}
			</Droppable>
		</StyledColumn>
	);
};

export default Column;

interface ColumnProps {
	column: any;
	options: any;
	isDragDisabled: boolean;
	onValueChange: (value: string) => void;
	floatToRight: boolean;
}

const StyledColumn = styled.div<{ $floatToRight: boolean }>`
	margin: 8px;
	border: 1px solid lightgray;
	border-radius: 10px;
	width: 50%;

	order: ${(props) => (props.$floatToRight ? 1 : 0)};

	@media (max-width: ${singleColumnMaxWidth}) {
		display: block;
		width: 100%;
		margin-left: 0;
	}
`;

const Title = styled.h3`
	margin: 0;
	padding: 8px;
	text-align: center;
	font-size: 18px;
`;

const OptionList = styled.div<{ $isDraggingOver: boolean }>`
	padding: 8px;
	flex-grow: 1;
	min-height: calc(100% - 72px);
	background-color: ${(props) => (props.$isDraggingOver ? props.theme.brandingColourLight : 'white')};
	border-radius: 10px;

	@media (max-width: ${singleColumnMaxWidth}) {
		min-height: 100px;
	}
`;
